<template>
  <div class="fd_body" v-if="body_show">
    <div class="men_list" v-if="recommend.length>0">
      <h1>推荐导师</h1>
      <ul>
        <li v-for="item in recommend" class="clearfix">
          <router-link :to="{path:'mentor_information',query:{'teacherid':item.teacherid}}">
            <img :src="item.picture" />
            <div class="men_r">
              <h2>{{item.name}}</h2>
              <h3>{{item.honor}}</h3>
              <h4>咨询量:{{item.count}}人 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;问题解决度:{{item.score}}分<span>¥{{item.price}}</span></h4>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="men_list" v-if="all.length>0">
      <h1>全部导师<span><a @click="list_click('score')" :class="{list_on: list_show=='score'}">问题解决度</a><a :class="{list_on: list_show=='count'}" @click="list_click('count')">咨询量</a></span></h1>
      <ul>
        <li v-for="item in all" class="clearfix">
          <router-link :to="{path:'mentor_information',query:{'teacherid':item.teacherid}}">
            <img :src="item.picture" />
            <div class="men_r">
              <h2>{{item.name}}</h2>
              <h3>{{item.honor}}</h3>
              <h4>咨询量：{{item.count}}人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;问题解决度：{{item.score}}分<span>¥{{item.price}}</span></h4>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {
  recommend
} from "@/api/totoring"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        recommend: [],
        all: [],
        hasmore: false,
        list_show: "score",
        loading: false,
      }
    },
    methods: {
      pullData() {
        recommend({
            position: this.$route.query.position,
            conditions: "score"
          })
          .then((data) => {
            shareCon("totoring", this);
            this.body_show = true;
            this.recommend = data.recommend;
            this.all = data.all;
            this.hasmore = data.hasmore;
          })
      },
      list_click(sv) {
        recommend({
            position: this.$route.query.position,
            conditions: sv
          })
          .then((data) => {
            this.all = data.all;
            this.hasmore = data.hasmore;
            this.list_show = sv;
            this.loading = false;
          })
      },
      hash() {
        if (this.loading) {
          return false;
        }
        this.loading = true;
        if (this.hasmore) {
          recommend({
              position: this.$route.query.position,
              conditions: this.list_show,
              count: this.all.length
            })
            .then((data) => {
              for (var currJson in data.all) {
                this.all.push(data.all[currJson]);
              };
              this.hasmore = data.hasmore;
              this.loading = false;
            })
        }
      },
      onScroll() {
        window.onscroll = (ev) => {
          //变量scrollTop是滚动条滚动时，距离顶部的距离  
          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;   //变量windowHeight是可视区的高度 
          let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;   //变量scrollHeight是滚动条的总高度   
          let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;         //滚动条到底部的条件             
          if (scrollTop + windowHeight == scrollHeight) {         //写后台加载数据的函数
            this.hash();       
          }  
        }
      }
    },
    created() {
      this.pullData();
    },
    mounted() {
      this.onScroll()
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.men_list {
  padding: 0 changeRem(.6)+px;
  margin-top: changeRem(.6)+px;
  text-align: left;
  h1 {
    font-size: changeRem(.72)+px;
    color: #333;
    font-weight: bold;
    span {
      float: right;
      display: inline-block;
      a {
        display: inline-block;
        width: changeRem(2.8)+px;
        height: changeRem(.8)+px;
        border: 2px solid rgba(245, 127, 23, 1);
        color: #F57F17;
        font-size: changeRem(.48)+px;
        line-height: changeRem(.8)+px;
        text-align: center;
      }
      .list_on {
        background: #F57F17;
        color: #fff;
      }
    }
  }
  ul li {
    width: 100%;
    height: auto;
    background: rgba(255, 255, 255, 1);
    border-radius: changeRem(.16)+px;
    margin-top: changeRem(.4)+px;
    padding: changeRem(.4)+px;
    a {
      display: block;
      width: 100%;
      height: 100%;
      img {
        width: changeRem(2.4)+px;
        height: changeRem(2.4)+px;
        vertical-align: middle;
        border-radius: 50%;
        float: left;
      }
      .men_r {
        width: changeRem(10.1)+px;
        float: right;
        padding-top: changeRem(.2)+px;
        h2 {
          color: #333;
          font-size: changeRem(.68)+px;
          font-weight: bold;
        }
        h3 {
          color: #333;
          font-size: changeRem(.52)+px;
          margin-top: changeRem(.2)+px;
          line-height: changeRem(.6)+px;
        }
        h4 {
          color: #999;
          font-size: changeRem(.4)+px;
          margin-top: changeRem(.2)+px;
          line-height: changeRem(.6)+px;
          span {
            float: right;
            color: #EB5032;
            font-size: changeRem(.56)+px;
            vertical-align: top;
          }
        }
      }
    }
  }
}
</style>
